import React from 'react';
import { dictionary } from '../../assets/dictionary';
import './medical-card-modal.scss';
import { Col, Container, Modal, Row } from 'react-bootstrap';

const notEligibleValues = ([key]: [string, unknown]): boolean =>
    !['id', 'createdAt', 'updatedAt', 'firstName', 'lastName'].includes(key);

function MedicalCardModal({ show, medicalCard, setShow }) {
    return (
        <Modal show={show} onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{medicalCard.firstName}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Container>
                    {Object.entries(medicalCard)
                        .filter(notEligibleValues)
                        .map(
                            (entry, index) =>
                                dictionary[entry[0]] && (
                                    <Row key={index}>
                                        <Col>
                                            {`${dictionary[entry[0]]}: ${
                                                entry[1]
                                                    ?.toString()
                                                    .replace('||', ', ') || '-'
                                            }`}
                                        </Col>
                                    </Row>
                                )
                        )}
                </Container>
            </Modal.Body>
        </Modal>
    );
}

export default MedicalCardModal;
